module.exports = __webpack_public_path__ + "img/Widget_card_headpics_SB_stage.a8e39289.jpg";